import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const EmployeeSalaryModal = ({ isOpen, onClose, year }) => {
  if (!isOpen) return null;

  // Employee data - this could come from props or API call
  const employees = [
    {
      name: 'Anderson, Kristin',
      type: 'hourly',
      hourlyRate: 37.00,
      standardRate: 37.00,
      jobCostingRate: 50.00,
      role: 'Support'
    },
    {
      name: 'Beridze, Nina',
      type: 'salary',
      annualSalary: 80000,
      hourlyRate: 38.46,
      jobCostingRate: 150.00,
      role: 'AM'
    },
    {
      name: 'Braverman, Megan',
      type: 'salary',
      annualSalary: 275000,
      hourlyRate: 132.21,
      jobCostingRate: 300.00,
      role: 'Principal'
    },
    {
      name: 'Crea, Alesondra',
      type: 'salary',
      annualSalary: 120000,
      hourlyRate: 57.69,
      jobCostingRate: 175.00,
      role: 'Sr AM'
    },
    {
      name: 'Jackson, Leeza',
      type: 'salary',
      annualSalary: 50000,
      hourlyRate: 24.04,
      jobCostingRate: 75.00,
      role: 'Mktg Support'
    },
    {
      name: 'Levis, Angely',
      type: 'salary',
      annualSalary: 83000,
      hourlyRate: 39.90,
      jobCostingRate: 150.00,
      role: 'AM'
    },
    {
      name: 'New Employee',
      type: 'new',
      annualSalary: 60000,
      monthlySalary: 5000,
      role: ''
    }
  ];

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div>
            <h2 className="text-xl font-semibold text-gray-900">
              Employee Salary Details
            </h2>
            <p className="text-sm text-gray-500 mt-1">
              Year: {year}
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <XMarkIcon className="w-6 h-6" />
          </button>
        </div>

        {/* Table */}
        <div className="flex-1 overflow-auto p-6">
          <table className="w-full">
            <thead className="bg-gray-50 sticky top-0">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                  Employee Name
                </th>
                <th className="px-4 py-3 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                  Annual/Hr
                </th>
                <th className="px-4 py-3 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                  Hourly Rate
                </th>
                <th className="px-4 py-3 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                  For Job Costing
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                  Role
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {employees.map((employee, index) => (
                <tr key={index} className="hover:bg-gray-50 transition-colors">
                  <td className="px-4 py-3 text-sm text-gray-900">
                    {employee.name}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-900 text-right font-mono">
                    {employee.type === 'hourly' && formatCurrency(employee.hourlyRate)}
                    {employee.type === 'salary' && formatCurrency(employee.annualSalary)}
                    {employee.type === 'new' && (
                      <div className="space-y-1">
                        <div className="text-xs text-gray-500">Annual</div>
                        <div>{formatCurrency(employee.annualSalary)}</div>
                      </div>
                    )}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-900 text-right font-mono">
                    {employee.hourlyRate ? formatCurrency(employee.hourlyRate) : ''}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-900 text-right font-mono">
                    {employee.jobCostingRate ? formatCurrency(employee.jobCostingRate) : ''}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600">
                    {employee.role}
                  </td>
                </tr>
              ))}
              
              {/* New Employee Row with Monthly breakdown */}
              <tr className="bg-blue-50 border-t-2 border-blue-200">
                <td className="px-4 py-3 text-sm font-medium text-gray-900">
                  New Employee
                </td>
                <td className="px-4 py-3 text-sm text-gray-900 text-right font-mono">
                  <div className="space-y-1">
                    <div className="text-xs text-gray-500">Monthly</div>
                    <div>{formatCurrency(5000)}</div>
                  </div>
                </td>
                <td className="px-4 py-3 text-sm text-gray-400 text-right">
                  
                </td>
                <td className="px-4 py-3 text-sm text-gray-400 text-right">
                  
                </td>
                <td className="px-4 py-3 text-sm text-gray-600">
                  
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 p-6 border-t border-gray-200 bg-gray-50">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmployeeSalaryModal;